export default {"src":"/uk/_next/static/media/spot-laptop.cec47c4e.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};